<template>
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
  <polyline class="cls-6" points="11.41 12.94 11.41 64.5 11.41 77.06 75.52 77.06"/>
  <polyline class="cls-6" points="11.41 65.6 20.32 55.52 28.32 63.47 60.21 26.34 67.83 31.93 75.52 22.18"/>
  <circle class="cls-1" cx="43.47" cy="45" r="15.57"/>
  <path class="cls-2" d="m43.47,61.66c-9.19,0-16.66-7.47-16.66-16.66s7.47-16.66,16.66-16.66,16.66,7.47,16.66,16.66-7.47,16.66-16.66,16.66Zm0-31.14c-7.99,0-14.49,6.5-14.49,14.49s6.5,14.49,14.49,14.49,14.49-6.5,14.49-14.49-6.5-14.49-14.49-14.49Z"/>
  <circle class="cls-5" cx="20.27" cy="56.31" r="3.07"/>
  <circle class="cls-5" cx="28.3" cy="63.13" r="3.07"/>
  <circle class="cls-5" cx="60.39" cy="26.87" r="3.07"/>
  <circle class="cls-5" cx="67.73" cy="31.41" r="3.07"/>
  <circle class="cls-5" cx="75.52" cy="22.18" r="3.07"/>
  <g>
    <rect class="cls-4" x="43.3" y="38.1" width=".33" height="15.7"/>
    <path class="cls-4" d="m49.46,54.13h-11.99c-1.2,0-2.18-.98-2.18-2.18v-11.99c0-1.2.98-2.18,2.18-2.18h11.99c1.2,0,2.18.98,2.18,2.18v11.99c0,1.2-.98,2.18-2.18,2.18Zm-11.99-15.7c-.84,0-1.52.68-1.52,1.52v11.99c0,.84.68,1.52,1.52,1.52h11.99c.84,0,1.52-.68,1.52-1.52v-11.99c0-.84-.68-1.52-1.52-1.52h-11.99Z"/>
    <g>
      <g>
        <path class="cls-3" d="m47.98,43.25c-.07,0-.13.02-.18.05-.53.4-1.27.65-2.08.65s-1.56-.25-2.09-.65c-.04-.03-.1-.05-.16-.05v-7.15h4.08l.43,7.16Z"/>
        <path class="cls-8" d="m45.72,44.06c-.81,0-1.58-.24-2.16-.68-.02-.02-.06-.03-.09-.03h-.11v-7.37h4.3l.44,7.38h-.12s-.09,0-.11.03c-.58.43-1.34.67-2.14.67Zm-2.14-.91s.08.03.12.06c.54.41,1.26.63,2.02.63s1.47-.22,2.01-.62c.04-.03.08-.05.13-.06l-.41-6.95h-3.87v6.95Z"/>
      </g>
      <g>
        <path class="cls-3" d="m39.37,36.09l-.43,7.16c-.05,0-.11.02-.15.05-.53.4-1.27.64-2.08.64-.07,0-.14,0-.2,0-1.82-.09-3.02-1.48-2.52-2.8l.22-.58,1.58-4.11c.08-.21.34-.36.63-.36h2.94Z"/>
        <path class="cls-8" d="m36.71,44.06c-.07,0-.14,0-.21,0-1.04-.05-1.94-.52-2.41-1.25-.34-.53-.42-1.13-.2-1.7l1.8-4.69c.1-.26.39-.43.74-.43h3.06l-.44,7.37h-.1s-.07.02-.09.03c-.57.43-1.33.67-2.14.67Zm-.28-7.85c-.25,0-.47.12-.53.29l-1.8,4.69c-.19.5-.13,1.03.18,1.5.44.67,1.27,1.1,2.24,1.15.07,0,.13,0,.2,0,.76,0,1.48-.22,2.01-.62.03-.03.07-.04.11-.06l.42-6.96h-2.83Z"/>
      </g>
      <path class="cls-7" d="m43.47,36.09v7.15c-.06,0-.12.02-.16.05-.53.4-1.27.65-2.09.65s-1.54-.25-2.08-.64c-.05-.04-.12-.06-.19-.05l.43-7.16h4.09Z"/>
      <path class="cls-7" d="m50.42,43.94c-.07,0-.13,0-.2,0-.81,0-1.55-.25-2.08-.65-.04-.03-.1-.05-.16-.05l-.43-7.16h2.97c.28,0,.53.14.61.35l1.58,4.13.22.58c.5,1.32-.7,2.7-2.52,2.8Z"/>
    </g>
    <path class="cls-4" d="m44.98,48.25c-.15,0-.27-.12-.27-.27v-1.26c0-.15.12-.27.27-.27s.27.12.27.27v1.26c0,.15-.12.27-.27.27Z"/>
    <path class="cls-4" d="m42.09,48.25c-.15,0-.27-.12-.27-.27v-1.26c0-.15.12-.27.27-.27s.27.12.27.27v1.26c0,.15-.12.27-.27.27Z"/>
    <path class="cls-4" d="m50.22,44.17c-.83,0-1.62-.25-2.21-.69-.02-.01-.07-.01-.09,0-.59.44-1.38.69-2.21.69s-1.63-.25-2.22-.7c-.01,0-.05,0-.06,0-.59.45-1.38.7-2.22.7s-1.62-.24-2.21-.69c-.02-.01-.07-.01-.08,0-.59.44-1.38.69-2.21.69-.07,0-.14,0-.21,0-1.07-.05-2.01-.54-2.5-1.3-.36-.56-.44-1.2-.21-1.8l1.8-4.7c.11-.3.45-.5.84-.5h14.09c.38,0,.71.2.82.49l1.8,4.71c.23.6.16,1.24-.21,1.8-.49.76-1.43,1.24-2.5,1.3-.07,0-.14,0-.21,0Zm-2.25-1.14c.11,0,.22.03.31.1.52.39,1.21.6,1.95.6.06,0,.13,0,.19,0,.93-.05,1.74-.46,2.15-1.1.29-.44.34-.94.17-1.4l-1.8-4.71c-.04-.1-.19-.21-.41-.21h-14.09c-.2,0-.38.09-.43.22l-1.8,4.69c-.18.46-.12.96.17,1.4.42.64,1.22,1.05,2.16,1.1.06,0,.13,0,.19,0,.74,0,1.43-.21,1.95-.6.17-.13.43-.13.61,0,.52.39,1.21.6,1.94.6s1.44-.22,1.96-.61c.17-.13.42-.13.59,0,.52.39,1.21.61,1.96.61s1.43-.21,1.95-.6c.09-.07.2-.1.31-.1Z"/>
  </g>
  </svg>
</template>

<script>
export default {
    name: "AllMetricsWoROMIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #fff;
  }
  .cls-2 {
    fill: #0f5b71;
  }
  .cls-3 {
    fill: #b3decd;
  }
  .cls-4 {
    fill: #115c72;
  }
  .cls-5 {
    fill: #0b5e73;
  }
  .cls-6 {
    fill: none;
    stroke: #59c5c7;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 3px;
  }
  .cls-7 {
    fill: #59c5c7;
  }
  .cls-8 {
    fill: #135d73;
  }
</style>